export class LogoEditionDialogData {
  constructor(public readonly image: string) {}
}
